(ns dre.components.radio-group
  (:require
   [dre.utils.bem :as bem]))

(def component-name :radio-group)

(defn- radio-group-item
  [{:keys [group-name on-change checked]}
   {:keys [id value text] :as option}]
  (let [{:keys [value text] :as option}
        (cond-> option
          (nil? value) (assoc :value id)
          (nil? text) (assoc :text id))]
    ^{:key id}
    [:div
     {:class (bem/be component-name :item)}
     [:input
      {:type :radio
       :id id
       :value value
       :name group-name
       :on-change #(on-change option)
       :class (bem/be component-name :input)
       :checked (= checked value)}]
     [:label
      {:for id
       :class (bem/be component-name :label)}
      text]]))

(defn radio-group
  [{:keys [vertical? options] :as props}]
  (let [default-props {:group-name (str (random-uuid))
                       :on-change (constantly nil)}
        props (merge default-props props)]
    [:div
     {:class [component-name (when vertical? :vertical)]}
     (map (partial radio-group-item props) options)]))
